import React from 'react';
import {Link} from '@shopify/hydrogen';

//components
import Blog from './Blog.client';

//types
import type {
  SanityBlogCategory,
  SanityDocBlog,
  SanityBlogTag,
} from '../../types';

interface BlogLabels {
  blogs_label: string;
  categories_label: string;
  tags_label: string;
  recent_posts_label: string;
}

interface Props {
  sanityCategories: SanityBlogCategory[] | undefined;
  sanityRecentBlogs: SanityDocBlog[] | undefined;
  sanityTags: SanityBlogTag[] | undefined;
  labels: BlogLabels | undefined;
}

export default function BlogListingSidebar({
  sanityRecentBlogs,
  sanityCategories,
  sanityTags,
  labels,
}: Props) {
  return (
    <div className="flex flex-col space-y-10 md:col-span-1">
      <div className="">
        <header className="mb-6">
          <h4 className="text-[20px] font-semibold">{labels?.recent_posts_label}</h4>
        </header>
        <ul className="grid gap-4">
          {sanityRecentBlogs &&
            sanityRecentBlogs.map((b) => (
              <li
                key={`blog-sidebar-${b._id}`}
                className="border-b border-black pb-4"
              >
                <Blog {...b} size="small" />
              </li>
            ))}
        </ul>
      </div>
      {sanityCategories && (
        <div className="">
          <header className="mb-6">
            <h4 className="text-[20px] font-semibold">{labels?.categories_label}</h4>
          </header>
          <ul className="grid gap-6">
            {sanityCategories.map((c) => {
              return (
                <li key={c._rev} className="border-b border-black pb-4">
                  <article className="blog">
                    <Link to={`/blogs/${c.slug.current}`}>
                      <h5 className="font-normal">{c.category_title}</h5>
                    </Link>
                  </article>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      {sanityTags && (
        <div className="">
          <header className="mb-6">
            <h4 className="text-[20px] font-semibold">{labels?.tags_label}</h4>
          </header>
          <ul className="flex flex-wrap space-x-4">
            {sanityTags.map((t) => {
              return (
                <li key={t._rev} className="border-b border-black">
                  <article className="blog">
                    <Link to={`/blogs/tags/${t.slug.current}`}>
                      <h5 className="font-normal">{t.title}</h5>
                    </Link>
                  </article>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
